import { AlertOctagon, ArrowRight } from 'lucide-react'
import { Link } from '@tanstack/react-router'

export interface CriticalAlert {
  label: string
  path: string
}

export function CriticalAlertStrip({ alerts }: { alerts: CriticalAlert[] }) {
  if (alerts.length === 0) return null
  return (
    <aside
      role="alert"
      className="flex items-center gap-3 border-b border-danger-border bg-danger-bg px-6 py-3"
    >
      <AlertOctagon size={16} className="flex-shrink-0 text-danger-text" aria-hidden="true" />
      <div className="flex min-w-0 flex-1 flex-wrap gap-x-4 gap-y-1">
        {alerts.map((a) => (
          <Link
            key={a.label}
            to={a.path}
            className="inline-flex items-center gap-1 text-sm font-medium text-danger-text hover:underline"
          >
            {a.label}
            <ArrowRight size={12} aria-hidden="true" />
          </Link>
        ))}
      </div>
    </aside>
  )
}
